<template>
	<div>
		<div class="row">
			<div class="col-12">
				<g-table-sync
					app="empresas"
					view="empresas_list"
					pagination="loadmore"
					:default-limit="12"
					:columns="columns"
					@edit="$router.push({name: 'empresa', params: {id: $event._EntityId}})"
				>
					<template
						slot="name"
						slot-scope="item"
					>
						<router-link
							tag="a"
							class="cursor text-primary"
							:to="{name: 'empresa', params: {id: item._EntityId}}"
						>
							<small>{{ item.EmpresaNombreComercial || item.EmpresaNombre }}</small>
						</router-link>
					</template>

					<template
						slot="address"
						slot-scope="item"
					>
						<small>{{ item.EmpresaDomicilioSocial }}</small>
					</template>

					<template
						slot="phone"
						slot-scope="item"
					>
						{{ item.EmpresaTelefono || item.EmpresaTelefonoMovil }}
					</template>
				</g-table-sync>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'EmpresasList',

	data() {
		return {
			id: 0,
			columns: [
				{
					title: 'ID',
					index: '_EntityId',
					order: true,
					search: true,
					width: '80px'
				},
				{
					title: 'Nombre Comercial',
					index: 'EmpresaNombreComercial',
					slot: 'name',
					order: true,
					search: true
				},
				{
					title: 'CIF/NIF',
					index: 'EmpresaCIF',
					search: true
				},
				{
					title: 'Direccion',
					index: 'EmpresaDomicilioSocial',
					slot: 'address',
					search: true
				},
				{
					title: 'Teléfono',
					index: 'EmpresaTelefono',
					slot: 'phone',
					width: '150px'
				},
				{
					title: 'Acciones',
					slot: '_actions'
				}
			]
		};
	},
	computed: {

	},
	methods: {
		edit(item) {
			console.log(item);
		}
	}
};
</script>

<style lang="scss"></style>
